import { ReactElement } from 'react';

import usePrivy from '~/lib/script/privy';
import { LAYOUT_TYPES } from '~/constants/global';

import { Footer, HijackedUser } from '~/components/global';
import NavHeader from '~/components/navigation/NavHeader';
import { ScrollToTop } from '~/components/ui';
import { AccountSidebar } from '~/components/account/Global';
import clsx from 'clsx';

export default function BaseLayout({
  children,
  className,
  pageType,
  accountPage,
  ...props
}: Readonly<{
  children: React.ReactNode;
  className?: string;
  pageType?: LAYOUT_TYPES;
  accountPage?: string;
}>): ReactElement {
  const isCollectionBrowsePage = (children as ReactElement)?.props
    ?.isCollectionBrowsePage;

  usePrivy();

  const isCartPage = pageType === LAYOUT_TYPES.CART;

  const classNames = clsx(
    isCartPage ? 'pt-[68px] md:pt-[85px]' : `pt-[111px] md:pt-[131px]`,
    pageType === LAYOUT_TYPES.CHECKOUT_COMPLETE && 'flex h-full grow',
  );

  const childComponent = accountPage ? (
    <AccountSidebar accountPage={accountPage}>{children}</AccountSidebar>
  ) : (
    children
  );

  return (
    <div className={className} {...props}>
      <NavHeader
        isCollectionBrowsePage={isCollectionBrowsePage}
        isCartPage={isCartPage}
      />
      <div id="appsumo-portal-root" />
      {/* Padding for fixed header */}
      <div id="headlessui-portal-root" className={classNames}>
        <HijackedUser />
        {childComponent}
      </div>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
